import './Home.scss';

import React, { useEffect } from 'react';
import { useTenant } from '../context/TenantContext';
import { BackButton } from '../components/buttons/Buttons';
import { removeSessionStorage } from '../services/storageService';
import HomeCard from '../components/cards/HomeCard';
import financiar from '../img/financiar.webp';
import logo from '../img/logo.svg';
import meliLogo from '../img/meli-logo.svg';
import refinanciar from '../img/refinanciar.webp';

const Home = () => {
  useEffect(() => {
    removeSessionStorage('simulationData');
    removeSessionStorage('leadId');
    removeSessionStorage('formData');
  }, []);

  const { isMeliTenant } = useTenant();
  return (
    <div className="home-container">
      <header>
        {isMeliTenant && <img src={meliLogo} alt="Meli Logo" className="meli-logo" />}
        <img src={logo} alt="Logo" className="app-logo" />
        <div className="header-text-container">
          <h1>Tipo de crédito</h1>
          <p>Selecciona la opción de financiamiento que necesitas</p>
        </div>
      </header>

      <div className="home-button-container">
        <HomeCard
          title="Financiamiento"
          description="Financiamos hasta el 80% del valor de tu vehículo"
          imgSrc={financiar}
          altText="Financiamiento"
          footerText="¡No lo pienses más, tu nuevo auto está cada vez más cerca!"
          linkTo="/credito-automotriz-simple"
        />

        {!isMeliTenant ? (
          <HomeCard
            title="Refinanciamiento"
            description="Baja la cuota de tu crédito automotriz aquí ¡100% online!"
            imgSrc={refinanciar}
            altText="Refinanciamiento"
            footerText="¡Hazlo realidad hoy! Refinancia tu crédito y siente el cambio"
            linkTo="/refinancia-tu-credito"
          />
        ) : (
          <></>
        )}
      </div>

      <BackButton />
    </div>
  );
};

export default Home;
